import axios from 'axios';
const base = 'motivobajatk';

function getAll(query = null) {
    return axios.get(base, {
        params: query
    });
}

function register(data) {
    return axios.post(base, data);
}

function update(data) {
    return axios.put([base, data.id_mbtk].join('/'), data);
}

function destroy(id) {
    return axios.delete([base, id].join('/'));
}

const MotivoBajaTkService = {
    getAll: getAll,
    register: register,
    update: update,
    destroy: destroy
};
export default MotivoBajaTkService;
